module.exports = __webpack_public_path__ + "img/panneau-bois-full.86797a4.svg";